import { SecondaryButtonComponent } from './secondary-button.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DemoMaterialModule } from 'src/app/demo-material-module';

@NgModule({
  imports: [
    CommonModule,
    DemoMaterialModule,
  ],
  declarations: [
    SecondaryButtonComponent
  ],
  exports: [
    SecondaryButtonComponent
  ]
})
export class SecondaryButtonModule { }
